var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgISetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_2272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C18.2092 8 20 6.20915 20 4C20 1.79086 18.2092 0 16 0C13.7908 0 12 1.79086 12 4C12 4.28745 12.0303 4.56775 12.0879 4.838L7.01695 7.3735C6.28365 6.5319 5.20395 6 4 6C1.79086 6 0 7.79085 0 10C0 12.2092 1.79086 14 4 14C5.2039 14 6.2836 13.4681 7.01695 12.6265L12.0879 15.162C12.0303 15.4323 12 15.7126 12 16C12 18.2092 13.7908 20 16 20C18.2092 20 20 18.2092 20 16C20 13.7908 18.2092 12 16 12C14.7961 12 13.7164 12.5319 12.9831 13.3735L7.91205 10.838C7.9697 10.5678 8 10.2874 8 10C8 9.7126 7.9697 9.43225 7.9121 9.162L12.9831 6.6265C13.7164 7.4681 14.7961 8 16 8Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_2272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgISetting);
export default __webpack_public_path__ + "static/media/i_setting.3d12b0f65d1e3a31b30054f0d6011b9e.svg";
export { ForwardRef as ReactComponent };